import React from 'react';
import PlannerFrame from './PlannerFrame';

const RailMountedCranePlanner = () => {
  return (
    <PlannerFrame
      title="Rail Mounted Crane Planner"
      src="/rail-mounted-crane-planner.html"
    />
  );
};

export default RailMountedCranePlanner;